import config from "./index";

async function fetchActivities() {
  const response = await fetch(`${config.apiUrl}/v1/activity`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authentication-Token": config.getToken(),
    },
  });
  const data = await response.json();
  return data;
}

export default {
  fetchActivities,
};
